// extracted by mini-css-extract-plugin
export default {"tagWrapper":"AboutTag_tagWrapper__CJvOK","deleteIconWrapper":"AboutTag_deleteIconWrapper__YpkUi","hidden":"AboutTag_hidden__wjEPA"};